import { Dispatch, SetStateAction, useState } from "react";
import { TOOLS_LIST } from "src/types/enum";

export type ImageGenerationChat = {
    isImageGenerationChat: boolean;
    setIsImageGenerationChat: Dispatch<SetStateAction<boolean>>;
    isGeneratingImage: boolean;
    setIsGeneratingImage: Dispatch<SetStateAction<boolean>>;
    selectedImageGenTool: string;
    setSelectedImageGenTool: Dispatch<SetStateAction<string>>;
}

const useImageGenerationChat = (): ImageGenerationChat => {
    const [isImageGenerationChat, setIsImageGenerationChat] = useState<boolean>(false);
    const [isGeneratingImage, setIsGeneratingImage] = useState<boolean>(false);
    const [selectedImageGenTool, setSelectedImageGenTool] = useState<TOOLS_LIST.NANO_BANANA | ''>('');

  return {
    isImageGenerationChat,
    setIsImageGenerationChat,
    isGeneratingImage,
    setIsGeneratingImage,
    selectedImageGenTool,
    setSelectedImageGenTool
  };
};

export default useImageGenerationChat;
